































import Vue, { PropType } from 'vue';
import { FileUploadBox } from '@descomplica/vue-components';
import { Document } from '@/store/modules/essay/state';
import i18n from '@/i18n';

export interface EssaySendFileFormEvent {
  fileName: string;
  fileDataUrl: string;
}

const FIVE_MB_IN_BYTES = 5 * 1024 ** 2;

export default Vue.extend({
  components: {
    FileUploadBox,
  },
  props: {
    currentDocument: {
      type: Object as PropType<Document>,
      required: true,
    },
    isDocumentUploadDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      done: false,
      fileName: this.currentDocument.name || '',
      fileDataUrl: '',
      maxFileSize: FIVE_MB_IN_BYTES,
      errorMessage: '',
    };
  },
  methods: {
    documentDeleteHandler(event: Event) {
      this.fileName = '';
      this.fileDataUrl = '';
      this.errorMessage = '';
      this.$emit('delete', event);
    },
    documentUploadHandler(file: File) {
      this.errorMessage = '';
      this.fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileDataUrl = reader.result as string;
        this.emitInputEvent();
      };
    },
    emitInputEvent() {
      const event: EssaySendFileFormEvent = {
        fileName: this.fileName,
        fileDataUrl: this.fileDataUrl,
      };

      this.$emit('input', event);

      this.fileDataUrl = '';
    },
    errorHandler(error: 'type' | 'size') {
      this.errorMessage = i18n.t(`fileUploadError.${error}`);
    },
  },
});
